/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, {
  InputHTMLAttributes, MouseEvent, useState
} from 'react'
import {
  FieldPath,
  FieldValues,
  get,
  RegisterOptions,
  useFormContext
} from 'react-hook-form'
import {
  StyledInput,
  StyledCheckMark,
  StyledLabel,
  CheckMarkWrapper
} from './style'

interface CheckBoxProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'required' | 'name'> {
  isChecked?: boolean
  name: FieldPath<FieldValues>
  label?: string
  required?: boolean | string
  registerOptions?: RegisterOptions
  disabled?: boolean
}

function CustomCheckBox ({
  isChecked = false,
  name,
  label,
  required,
  registerOptions = {},
  onChange,
  disabled,
  ...attributes
}: CheckBoxProps) {
  const {
    register,
    setValue,
    formState: { errors }
  } = useFormContext<FieldValues>()

  const [checked, setChecked] = useState(isChecked)
  const error = get(errors, name)

  const registerResult = register(name, {
    required,
    ...registerOptions
  })

  const toggleChecked = (event: MouseEvent<HTMLLabelElement>) => {
    event.preventDefault()

    if (disabled ?? false) {
      return
    }

    setChecked((prev) => {
      setValue(name, !prev)
      return !prev
    })
  }

  return (
    <CheckMarkWrapper onClick={(event) => toggleChecked(event)} isChecked={checked}>
      <StyledInput
        type="checkbox"
        aria-describedby={name}
        required={!!required}
        aria-required={!!required}
        checked={checked}
        {...attributes}
        {...registerResult}
        onChange={(event) => {
          registerResult.onChange(event)
          onChange?.(event)
        }}
      />
      <StyledCheckMark
        hasError={error}
        disabled={disabled}
        isChecked={checked}
      />
      <StyledLabel disabled={disabled}>{label}</StyledLabel>
    </CheckMarkWrapper>
  )
}

export default CustomCheckBox
